var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "bg-white pb-1 pt-6" },
    [
      _c(
        "LoadingOverlay",
        { attrs: { loading: _vm.isActivitiesLoaded, hasData: _vm.hasData } },
        [
          _vm.isListEmpty
            ? _c(
                "EmptyListPlaceholder",
                {
                  attrs: {
                    title: "There are no custom requests at the moment",
                    subtitle: _vm.emptyListSubtitle,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "image",
                        fn: function () {
                          return [_c("EmptyListImageRequests")]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2557147869
                  ),
                },
                [
                  _vm.ableToCreateCustomRequest
                    ? _c("ProjectCustomRequest", {
                        attrs: {
                          project: _vm.project,
                          currentUserId: _vm.currentUserId,
                          companyId: _vm.companyId,
                        },
                        on: { customRequestCreated: _vm.refetch },
                      })
                    : _vm._e(),
                ],
                1
              )
            : [
                _c(
                  "div",
                  { staticClass: "flex w-full pb-6 px-7" },
                  [
                    _vm.ableToCreateCustomRequest
                      ? _c("ProjectCustomRequest", {
                          staticClass: "ml-auto",
                          attrs: {
                            project: _vm.project,
                            currentUserId: _vm.currentUserId,
                            companyId: _vm.companyId,
                          },
                          on: { customRequestCreated: _vm.refetch },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "table",
                  {
                    staticClass:
                      "relative w-auto text-sm text-bold text-left dark:text-gray-400 mb-2 mx-7",
                  },
                  [
                    _c(
                      "thead",
                      {
                        staticClass: "text-m text-black customBackgroundColor",
                      },
                      [
                        _c("tr", [
                          _c(
                            "th",
                            {
                              staticClass: "py-4 text-sm relative pl-4",
                              staticStyle: { width: "10%" },
                              attrs: { scope: "col" },
                            },
                            [
                              _vm._v(" Status"),
                              _c("span", {
                                staticClass:
                                  "right-border px-2 absolute right-2",
                              }),
                            ]
                          ),
                          _c(
                            "th",
                            {
                              staticClass: "py-4 text-sm relative",
                              staticStyle: { width: "12%" },
                              attrs: { scope: "col" },
                            },
                            [
                              _vm._v(" Position "),
                              _c("span", {
                                staticClass:
                                  "right-border px-2 absolute right-2",
                              }),
                            ]
                          ),
                          _c(
                            "th",
                            {
                              staticClass: "py-4 text-sm relative",
                              staticStyle: { width: "20%" },
                              attrs: { scope: "col" },
                            },
                            [
                              _vm._v(" Skills required for position "),
                              _c("span", {
                                staticClass:
                                  "right-border px-2 absolute right-2",
                              }),
                            ]
                          ),
                          _c(
                            "th",
                            {
                              staticClass: "py-4 text-sm relative",
                              staticStyle: { width: "20%" },
                              attrs: { scope: "col" },
                            },
                            [
                              _vm._v(" Suggested resource "),
                              _c("span", {
                                staticClass:
                                  "right-border px-2 absolute right-2",
                              }),
                            ]
                          ),
                          _c(
                            "th",
                            {
                              staticClass: "py-4 text-sm relative",
                              staticStyle: { width: "18%" },
                              attrs: { scope: "col" },
                            },
                            [
                              _vm._v(" Description "),
                              _c("span", {
                                staticClass:
                                  "right-border px-2 absolute right-2",
                              }),
                            ]
                          ),
                          _c(
                            "th",
                            {
                              staticClass: "py-4 text-sm relative",
                              staticStyle: { width: "15%" },
                              attrs: { scope: "col" },
                            },
                            [_vm._v(" Requested by ")]
                          ),
                          _c("th", {
                            staticClass: "px-2 py-4 text-sm",
                            staticStyle: { width: "5%" },
                            attrs: { scope: "col" },
                          }),
                        ]),
                      ]
                    ),
                    _vm._l(_vm.requests, function (request) {
                      return _c("CustomRequestCard", {
                        key: request.id,
                        attrs: {
                          request: request,
                          createdBy: request.created_by,
                          skills: request.skills,
                          currentUserId: _vm.currentUserId,
                          companyId: _vm.companyId,
                          isAdmin: _vm.isAdmin,
                        },
                        on: { refetch: _vm.refetch },
                      })
                    }),
                  ],
                  2
                ),
                _c("CardPagination", {
                  attrs: { config: _vm.paginationConfig },
                  on: {
                    "update:config": function ($event) {
                      _vm.paginationConfig = $event
                    },
                  },
                }),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }